import { queryParamHas } from '../../helpers/getQueryParam'
import Logger from '../../helpers/Logger'
import type { Slot } from '../../slots/Slot'
import * as defaultNativeTemplates from '../templates'

export const getTemplateName = ({
  target,
  slotName
}: Pick<Slot, 'target' | 'slotName'>) =>
  (target && target.getAttribute('data-native-template')) || slotName

export const getTemplate = ({
  model,
  target,
  slotName
}: Pick<Slot, 'model' | 'target' | 'slotName'>): string => {
  const templateName = getTemplateName({ target, slotName })

  // Temporarily disabling trellis ads while they fix them
  if (
    document.body.classList.contains('mvt-js')
    && !queryParamHas('enableTrellisNative', 'true')
  ) {
    return defaultNativeTemplates[templateName]
  }

  const template =
    (model.native_html_templates &&
      model.native_html_templates[templateName]) ||
    defaultNativeTemplates[templateName]

  if (!template) {
    Logger.debug(`Cannot find a template name for ${slotName}!`)
    return ''
  }

  return template
}
